import { render, staticRenderFns } from "./CustomerAssistance.vue?vue&type=template&id=950bb140&scoped=true&"
import script from "./CustomerAssistance.vue?vue&type=script&lang=js&"
export * from "./CustomerAssistance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "950bb140",
  null
  
)

export default component.exports